import React from 'react'
import { ElasticSearchResponse, GeneralDocument } from './models'

function escapeRegExp(str: string): string {
  return str.replace(/[.*+?^=!:${}()|[\]\\/]/g, '\\$&') // Escape only necessary characters
}

export const highlightText = (text: string, searchValue: string | undefined) => {
  if (!searchValue) return text // Return original text if no search value
  const safeSearchValue = escapeRegExp(searchValue)
  const regex = new RegExp(`(${safeSearchValue})`, 'gi') // Create a regex to match the search value
  const parts = text?.split(regex) // Split the text by search value

  return parts?.map((part, index) =>
    part.toLowerCase() === searchValue.toLowerCase() ? <span key={index}>{part}</span> : part
  )
}

export const handleKeyDown = (
  e: { key: string; preventDefault: () => void; stopPropagation: () => void },
  searchValue?: string,
  searchData?: ElasticSearchResponse<GeneralDocument> | null
) => {
  // e.stopPropagation();
  if (e.key === 'Enter') {
    // Prevent the default action if needed
    e.preventDefault()

    // Perform the search or any other action
    if (searchValue && searchData)
      window.location.href = `${currentLang}/search-result?q=${encodeURIComponent(searchValue)}`
  }
}

export const handleKeyDownHeader = (
  e: { key: string; preventDefault: () => void; stopPropagation: () => void },
  searchValue?: string,
  searchData?: ElasticSearchResponse<GeneralDocument> | null
) => {
  // e.stopPropagation();
  if (e.key === 'Enter') {
    // Prevent the default action if needed
    e.preventDefault()

    // Perform the search or any other action
    if (searchValue && searchData)
      window.location.href = `${currentLang}/search-result?q=${encodeURIComponent(searchValue)}`
  }
}

const data: Drupalsetting = window?.drupalSettings // Getting the data from the window object

// Find the 'elasticSearchTheme' component
const elasticSearchTheme = data?.bsi_components_api?.find(
  (item) => item.componentKey === 'elasticSearchTheme'
)

// Access the `elasticSearchPlacehoder` value from storage
const PlaceholderComponent = data?.bsi_components_api?.find(
  (item) => item.componentKey === 'elasticSearchPlaceholder'
)

// Access the `elasticSearchEnvironment` value from storage
const searchEnvironmentComponent = data?.bsi_components_api?.find(
  (item) => item.componentKey === 'elasticSearchEnvironment'
)

// Access the `elasticSearchResultLink` value from storage
const elasticSearchResultLink = data?.bsi_components_api?.find(
  (item) => item.componentKey === 'elasticSearchResultLink'
)

const elasticSearchPlaceholderImage = data?.bsi_components_api?.find(
  (item) => item.componentKey === 'elasticSearchPlaceholderImage'
)

// Access the `isLight` value from the first item in the `theme` array
export const isLight = elasticSearchTheme?.theme?.[0]?.isLight?.toLowerCase() === 'true'

export const placeholder =
  PlaceholderComponent?.placeholder || 'Search for products, experiences or cocktails'

export const resultDetailLinkText = elasticSearchResultLink?.searchResultLink || 'Read More'

export const BrandPlaceholderImage = elasticSearchPlaceholderImage?.placeholderImage?.card_1_1

export const currentLang =
  data?.path?.currentLanguage !== 'en' ? `/${data?.path?.currentLanguage}` : ''

export const environment = searchEnvironmentComponent?.environment || ''

export const storeName = searchEnvironmentComponent?.storename || ''
